import React from 'react';

import { ModelTable } from '../../../components';
import { Column, Image } from '@smartplatform/ui';

export const AddressList = ({ rootPath, tabName }) => {
	const options = { include: ['division', 'city'], order: 'street asc, building asc nulls last' };
	return (
		<ModelTable
			model="Address"
			options={options}
			rootPath={rootPath}
			path={'/admin/divisions/addresses'}
			tabName={tabName}
			limit={20}
			showAddButton={false}
		>
			<Column property="street" label="Улица" />
			<Column property="building" label="Дом" />
			<Column relation="city" property="name" label="Город" />
			<Column relation="division" property="name" label="Избирательный округ" />
		</ModelTable>
	);
};
